import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(main)/models/(show)/[id]/_ui/ModelDescription/ModelDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(main)/models/(show)/[id]/_ui/ModelGallery/ModelGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(main)/models/(show)/[id]/_ui/ModelInfo/ModelInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(main)/models/(show)/[id]/_ui/ModelPreview/ModelPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
